import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import Link from 'PMT/components/Link';
import RoutingEnum from 'constants/RoutingEnum';
import I18n from 'PMT/i18n/I18n';

// Is hidden by default to remove ugly effect. Will be display after page loading (see window.js)
function Footer(): Object {
  return (
    <footer className="footer col-sm-offset-2 col-sm-10 col-xs-12">
      <div className="footer_links">
        <div className="footer_info text-center">
          © PayMyTable 2016. {I18n.tr('components.footer.rights_reserved')}.
          &nbsp;<Link to={RoutingEnum.CGU}>
            {I18n.tr('components.footer.cgu')}
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./scripts/components/footer/index.js